import _ from 'lodash'
import { Message } from 'element-ui'
import Vue from 'vue'
import api from '@/api'
import storage from '@/utils/storage'
import { SET_SHOPPING_CART, SET_PROMOTIONS_SHOPPING_CART } from '../mutation-types'
import { parse } from "date-fns";


//购物车内商品属性e.g
const goods_in_card_eg = {
  goodsAmount: NaN,
  goodsEnglishName: '',
  goodsName: '',
  goodsId: '',
  goodsImg: '',
  goodsOid: '',
  goodsStockAmount: NaN,
  isSelf: '',
  isAdvance: '',
  memberPrice: NaN,
  checked: false,
}
//单独活动属性e.g
const promotion = {
  goodsActionTypeId: '',
  goodsActionTypeName: '',
  goodsActionTypeNameEn: '',
  startTime: '',
  endTime: '',
  pickupShopList: [],
  shoppingCart: [],
}

const state = {
  //goods in cart list
  shoppingCart: [],
  //
  promotionsShoppingCart: [],
}
const mutations = {
  [SET_SHOPPING_CART](state, shoppingCart) {
    Vue.set(state, 'shoppingCart', shoppingCart)
    storage.set('shoppingCart', JSON.stringify(shoppingCart))

  },
  [SET_PROMOTIONS_SHOPPING_CART](state, promotionsShoppingCart) {
    Vue.set(state, 'promotionsShoppingCart', promotionsShoppingCart)
    storage.set('promotionsShoppingCart', JSON.stringify(promotionsShoppingCart))
  }
}

const actions = {
  /**
   * 购物车初始化逻辑：
   * 1. 打开网站后如果是登录状态，既token保持登录状态 本次初始化 只取远程返回值，并清理-重新赋值缓存信息
   * 2. 打开网站后如果是非登录状态，既无token保持未登录状态,本次初始化只取缓存信息，
   * 在登录后将缓存信息同步至服务器,并通过服务器重新获取更新后的数据。
   * 3. 活动购物车不使用上述逻辑，活动购物车只使用客户端缓存信息并不参与数据更新同步
   * 4. 活动购物车会在初始化阶段重新检查活动时间范围 并在过期后提醒并删除过期活动数据(缓存)
   * init ShoppingCart
   * @param {*} param0
   */
  initShoppingCart({ commit, rootState, rootGetters }) {
    //init shoppingCart
    let shoppingCartInSession = JSON.parse(storage.get('shoppingCart') || '[]')
    if (rootGetters.isLogin) {
      api.cart.getShoppingCart().then(
        res => {
          let { result: { list } } = res
          list = list || []
          list.forEach(e => e.checked = false)
          commit(SET_SHOPPING_CART, list)
        }
      ).catch(
        err => {
          // console.log(err)
        }
      )
    } else {
      commit(SET_SHOPPING_CART, shoppingCartInSession)
    }

    // init promotions
    let promotionsShoppingCart = JSON.parse(storage.get('promotionsShoppingCart') || '[]');
    commit(SET_PROMOTIONS_SHOPPING_CART, promotionsShoppingCart)

  },
  updateCartStorage({ state, rootState }) {
    //更新db
    // rootState.user.token && api.cart.updateCart(state.shoppingCart)
    //更新缓存
    // console.log(state)
    storage.set('shoppingCart', JSON.stringify(state.shoppingCart))
    storage.set('promotionsShoppingCart', JSON.stringify(state.promotionsShoppingCart))

  },
  /**
   * 修改商品数量
   * @param {*} param0
   * @param {*} goods
   * @param {*} promotion
   */
  changeCart({ commit, state, rootState, dispatch }, params) {
    const { goods, promotion } = params;
    const { goodsId, goodsAmount, changeAmount } = goods;
    let changed = true;
    if (_.isEmpty(promotion)) {//promotion为空则默认普通商品
      //判断当前购物车内是否有该商品
      let shoppingCart = state.shoppingCart;
      let idx = shoppingCart.map(e => e.goodsId).indexOf(goodsId);

      if (idx > -1) {
        //如果有修改数量
        if (changeAmount > 0) {
          shoppingCart[idx].goodsAmount = _.add(shoppingCart[idx].goodsAmount, changeAmount)
        } else if (changeAmount <= 0) {
          shoppingCart[idx].goodsAmount = _.subtract(shoppingCart[idx].goodsAmount, Math.abs(changeAmount))
        } else {
          shoppingCart[idx].goodsAmount = goodsAmount
        }
        if (shoppingCart[idx].goodsAmount >= shoppingCart[idx].goodsStockAmount
          && shoppingCart[idx].isAdvance == '1') {
          changed = false
          shoppingCart[idx].goodsAmount = shoppingCart[idx].goodsStockAmount
          Message({ type: "warning", message: 'The quantity available for purchase has reached its maximum' })
        }
        // shoppingCart[idx].goodsAmount = goodsAmount
        if (shoppingCart[idx].goodsAmount <= 0) {
          shoppingCart.splice(idx, 1)
        }
      } else {
        //如果没有置顶添加
        goods.goodsAmount = changeAmount
        shoppingCart.unshift(goods)
      }
      //更新store
      commit(SET_SHOPPING_CART, shoppingCart)
      //更新db
      console.log(shoppingCart[0].goodsAmount, goodsAmount, changeAmount)
      if (goodsAmount) {
        // console.log(shoppingCart, idx)
        rootState.user.token && api.cart.changeCart({ goodsId: goodsId, goodsAmount: shoppingCart[idx].goodsAmount })
      } else {
        rootState.user.token && api.cart.addCart({ goodsId: goodsId, goodsAmount: changeAmount })
      }


    } else {//如果不为空则默认为活动接龙商品(多个活动直接不可同时下单)

      let { goodsActionTypeId } = promotion
      let promotionsShoppingCart = state.promotionsShoppingCart
      let idxPromotions = promotionsShoppingCart.map(e => e.goodsActionTypeId).indexOf(goodsActionTypeId)
      // console.log('idxPromotions：' + idxPromotions)
      console.log(goods.isAdvance, goods.goodsStockAmount, idxPromotions)
      if (goods.isAdvance == "1" && goods.goodsStockAmount == 0) {
        changed = false
        Message({ type: "warning", message: 'The quantity available for purchase has reached its maximum' })
      } else {
        if (idxPromotions > -1) {
          //判断当前购物车内是否有该商品
          let promotionInList = promotionsShoppingCart[idxPromotions]
          let { shoppingCart } = promotionInList
          let idx = shoppingCart.map(e => e.goodsId).indexOf(goodsId)
          if (idx > -1) {
            //如果有修改数量
            // shoppingCart[idx].goodsAmount = _.add(shoppingCart[idx].goodsAmount,goodsAmount)
            if (changeAmount > 0) {
              shoppingCart[idx].goodsAmount = _.add(shoppingCart[idx].goodsAmount, changeAmount)
            } else if (changeAmount <= 0) {
              shoppingCart[idx].goodsAmount = _.subtract(shoppingCart[idx].goodsAmount, Math.abs(changeAmount))
            } else {
              shoppingCart[idx].goodsAmount = goodsAmount
            }
            //
            if (shoppingCart[idx].goodsAmount >= shoppingCart[idx].goodsStockAmount
              && shoppingCart[idx].isAdvance == '1') {
              changed = false
              shoppingCart[idx].goodsAmount = shoppingCart[idx].goodsStockAmount
              Message({ type: "warning", message: 'The quantity available for purchase has reached its maximum' })
            }

            // shoppingCart[idx].goodsAmount = goodsAmount
            if (shoppingCart[idx].goodsAmount <= 0) {
              shoppingCart.splice(idx, 1)
            }
          } else {

            //如果没有置顶添加
            shoppingCart.unshift(goods)

          }
        } else {

          let promotionNew = Object.assign({}, promotion)
          promotionNew.shoppingCart = []
          promotionNew.shoppingCart.unshift(goods)
          promotionsShoppingCart.unshift(promotionNew)
          // console.log('promotionsShoppingCart' + promotionsShoppingCart)
        }
      }

      //更新store
      commit(SET_PROMOTIONS_SHOPPING_CART, promotionsShoppingCart)
    }
    changed ?
      Message({ message: "successfully", type: "success" }) : void

      dispatch('updateCartStorage')
  },

  /**
   * 移除指定商品
   * @param {*} param0
   * @param {*} goodsId @notnull
   * @param {*} goodsActionTypeId
   */
  removeCart({ commit, state, rootState, dispatch }, { goodsId, goodsActionTypeId }) {

    if (_.isEmpty(goodsActionTypeId)) {
      let idx = state.shoppingCart.map(e => e.goodsId).indexOf(goodsId);
      let shoppingCart = state.shoppingCart;
      if (idx > -1) {
        shoppingCart.splice(idx, 1)
      }
      rootState.user.token && api.cart.removeCart(goodsId)
      commit(SET_SHOPPING_CART, shoppingCart)
    } else {

      let promotionsShoppingCart = state.promotionsShoppingCart
      let idxPromotions = promotionsShoppingCart.map(e => e.goodsActionTypeId).indexOf(goodsActionTypeId)
      if (idxPromotions > -1) {
        //判断当前购物车内是否有该商品
        let promotionInList = promotionsShoppingCart[idxPromotions]
        let { shoppingCart } = promotionInList
        let idx = shoppingCart.map(e => e.goodsId).indexOf(goodsId)
        if (idx > -1) {
          shoppingCart.splice(idx, 1)
        }
        //删除后如果购物车空了那么删除这个活动 购物车
        if (shoppingCart.length === 0) {
          promotionsShoppingCart.splice(idxPromotions, 1)
        }
      }
      commit(SET_PROMOTIONS_SHOPPING_CART, promotionsShoppingCart)
    }
    dispatch('updateCartStorage')
  },
  afterOrderClearCart() {

  },
  /**
   * 全选/全部取消
   * @param {*} param0
   * @param {*} goodsActionTypeId 指定系列
   */
  checkedAll({ commit, state }, goodsActionTypeId) {
    if (_.isEmpty(goodsActionTypeId)) {
      let shoppingCart = state.shoppingCart
      let isAllchecked = true;
      shoppingCart.foreach(e => { isAllchecked = e.checked && isAllchecked })
      shoppingCart.foreach(goods => {
        goods.checked = !isAllchecked
      })
      commit(SET_SHOPPING_CART, shoppingCart)
    } else {
      let promotionsShoppingCart = state.promotionsShoppingCart
      let idxPromotions = promotionsShoppingCart.map(e => e.goodsActionTypeId).indexOf(goodsActionTypeId)
      if (idxPromotions > -1) {
        let promotionInList = promotionsShoppingCart[idxPromotions]
        let { shoppingCart } = promotionInList
        let isAllchecked = true;
        shoppingCart.foreach(e => { isAllchecked = e.checked && isAllchecked })
        shoppingCart.foreach(goods => {
          goods.checked = !isAllchecked
        })
        commit(SET_PROMOTIONS_SHOPPING_CART, promotionsShoppingCart)
      }
    }
  },
  /**
   * 清理所有选中
   * @param {*} param0
   * @param {*} goodsActionTypeId
   */
  removeCheckedAll({ commit, state }, goodsActionTypeId) {
    if (_.isEmpty(goodsActionTypeId)) {
      let shoppingCart = state.shoppingCart
      shoppingCart.forEach(goods => {
        goods.checked = false
      })
      commit(SET_SHOPPING_CART, shoppingCart)

    } else {
      let promotionsShoppingCart = state.promotionsShoppingCart
      let idxPromotions = promotionsShoppingCart.map(e => e.goodsActionTypeId).indexOf(goodsActionTypeId)
      if (idxPromotions > -1) {
        let promotionInList = promotionsShoppingCart[idxPromotions]
        let { shoppingCart } = promotionInList
        shoppingCart.forEach(goods => {
          goods.checked = false
        })
        commit(SET_PROMOTIONS_SHOPPING_CART, promotionsShoppingCart)
      }
    }
  },
  /**
   * 选中/取消 指定商品
   * @param {*} param0
   * @param {*} goodsId
   * @param {*} goodsActionTypeId
   */
  checkedGoods({ commit, state }, { goodsId, goodsActionTypeId }) {
    // console.log(goodsId, goodsActionTypeId)
    if (_.isEmpty(goodsActionTypeId)) {
      let idx = state.shoppingCart.map(e => e.goodsId).indexOf(goodsId)
      let shoppingCart = state.shoppingCart;
      // console.log(shoppingCart)
      if (idx > -1) {
        shoppingCart[idx].checked = !shoppingCart[idx].checked
      }
      // console.log(shoppingCart)
      commit(SET_SHOPPING_CART, shoppingCart)
    } else {

      let promotionsShoppingCart = state.promotionsShoppingCart
      let idxPromotions = promotionsShoppingCart.map(e => e.goodsActionTypeId).indexOf(goodsActionTypeId)
      if (idxPromotions > -1) {
        let promotionInList = promotionsShoppingCart[idxPromotions]
        let { shoppingCart } = promotionInList
        let idx = shoppingCart.map(e => e.goodsId).indexOf(goodsId)
        if (idx > -1) {
          shoppingCart[idx].checked = !shoppingCart[idx].checked
        }
        commit(SET_PROMOTIONS_SHOPPING_CART, promotionsShoppingCart)
      }
    }
  },
  /**
   * 清除所有的购物车信息
   * @param {*} param0
   */
  cleanShoppingCart({ commit }) {
    storage.remove('shoppingCart')
    commit(SET_SHOPPING_CART, [])
  },
  /**
   * 清除所有的活动购物车信息
   * @param {*} param0
   */
  cleanPromotionsShoppingCart({ commit }) {
    storage.remove('promotionsShoppingCart')
    commit(SET_PROMOTIONS_SHOPPING_CART, [])
  },
  /**
   * 提交购物车数据并返回整体购物车信息
   * @param {*} param0
   * @param {*} goodsList
   */
  updateCart({ commit, state, dispatch }) {

    api.cart.updateCart('DirectMailCart', state.shoppingCart).then(res => {
      let { result: { list: shoppingCart } } = res;
      shoppingCart.forEach(sc => sc.checked = false)
      commit(SET_SHOPPING_CART, shoppingCart)
      dispatch('updateCartStorage')
    })
  },
  cleanExpiredCart({ commit, state }) {
    let promotionsShoppingCart = state.promotionsShoppingCart
    promotionsShoppingCart = promotionsShoppingCart.filter(promotion => {
      const endTime = parse(promotion.endTime, "dd/MM/yyyy HH:mm", new Date()).getTime()
      // console.log(new Date().getTime(), endTime)
      return new Date().getTime() < endTime;
    });
    commit(SET_PROMOTIONS_SHOPPING_CART, promotionsShoppingCart)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/cart.js